/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('errorsBox', [
  '$rootScope',

  function ($rootScope) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/errors-box.html'),

      replace: true,

      scope: {
        errors: '=ngModel',
      },

      link(scope, element, attrs) {},
    };
  },
]);
